import { apiClient } from './api-client';
import {
    DisputesSchema,
    MarketSchema,
    MarketsSchema,
    SettlementSchema,
    type Dispute,
    type Market,
    type MarketKind,
} from '../schemas/market.schema';

export interface CreateMarketInput {
    kind: MarketKind;
    question: string;
    detail?: string;
    closesInSeconds: number;
    outcomes?: string[];
    entrantIds?: number[];
    lineValue?: number;
    buyIn?: number;
    minParticipants?: number;
    joinDeadlineSeconds?: number;
    resolverId?: number;
}

export interface PlaceBetInput {
    marketId: number;
    outcomeId?: number;
    guessValue?: number;
    stake: number;
    /** Generated once per attempt so a retry cannot double-stake. */
    idempotencyKey: string;
}

export const marketsService = {
    list: (): Promise<Market[]> => apiClient.get('markets', MarketsSchema),

    get: (id: number): Promise<Market> => apiClient.get(`markets/${id}`, MarketSchema),

    create: (input: CreateMarketInput): Promise<Market> =>
        apiClient.post('markets', input, MarketSchema),

    bet: ({ marketId, ...body }: PlaceBetInput): Promise<unknown> =>
        apiClient.post(`markets/${marketId}/bets`, body),

    enter: (marketId: number, idempotencyKey: string): Promise<unknown> =>
        apiClient.post(`markets/${marketId}/enter`, { idempotencyKey }),

    resolve: (marketId: number, body: { outcomeId?: number; resolvedValue?: number }) =>
        apiClient.post(`markets/${marketId}/resolve`, body, SettlementSchema),

    lock: (marketId: number): Promise<void> => apiClient.post(`markets/${marketId}/lock`),


    dispute: (marketId: number, reason: string): Promise<unknown> =>
        apiClient.post(`markets/${marketId}/disputes`, { reason }),

    disputes: (marketId: number): Promise<Dispute[]> =>
        apiClient.get(`markets/${marketId}/disputes`, DisputesSchema),

    voteOnDispute: (disputeId: number, agrees: boolean): Promise<unknown> =>
        apiClient.post(`disputes/${disputeId}/votes`, { agrees }),

};
